import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCrmPath } from "@core/schema/paths/getCrmPath.js";
import { getEcommercePath } from "@core/schema/paths/getEcommercePath.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";

export function getProsAccounting(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Účetní software na míru",
			desc: "Přerostl vám účetní software nebo fakturační systém přes hlavu? Vyvineme pro vás nový na míru, se kterým vše vyřešíte online a rychle. Bude umět přesně to, co vaše firma potřebuje, bez zbytečných funkcí navíc.",
		},
		{
			title: "Digitalizace a automatizace účetnictví i objednávek",
			desc: "Účetní operace ani vyřizování objednávek už nemusíte řešit ručně. Digitalizujeme a automatizujeme pro vás jak účetní transakce (např. vystavení dokladů a zaslání e-mailu), tak proces objednávek – od vzniku až po přijetí platby.",
		},
		{
			title: "Propojení více systémů",
			desc: `Není nic horšího než chaos ve firemních systémech. Postaráme se o [${getIntegrationsPath(tenant)}][[integraci]] vašeho účetnictví se skladovým hospodářstvím, fakturačním softwarem, [${getCrmPath(tenant)}][[CRM systémem]] nebo třeba [${getEcommercePath(tenant)}][[e-shopem]]. Zvládneme vás napojit i na systémy třetích stran.`,
		},
		{
			title: "Legislativní záležitosti",
			desc: "Obáváte se, že při digitalizaci a automatizaci účetnictví nezvládnete dodržet zákonné požadavky? Žádný strach, pomůžeme vám také s legislativními náležitostmi, abyste měli vše v pořádku.",
		},
	];
}
